import React, { ReactElement, useCallback } from 'react';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { useIntl } from 'react-intl';
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { radioControlRootSx } from './styles';
import type { RadioControlProps } from './types';

export function RadioControl({
  filter,
  localSetter,
  localValue,
  disabled,
}: RadioControlProps): ReactElement {
  const intl = useIntl();
  const { available, labelId, labels } = filter;

  const handleChange = useCallback(
    (_: React.ChangeEvent<HTMLInputElement>, value: string) => {
      localSetter(value);
    },
    [localSetter]
  );

  return (
    <Box sx={radioControlRootSx}>
      <FormControl variant="standard" component="fieldset" disabled={disabled}>
        <FormLabel component="legend">
          {formatTranslation(intl, unsafeTranslationKey(labelId))}
        </FormLabel>
        <RadioGroup
          aria-label="chart-type"
          name="chart-type"
          value={localValue}
          onChange={handleChange}
        >
          {available?.map((availableValue: string) => (
            <FormControlLabel
              value={availableValue}
              control={<Radio color="primary" />}
              label={formatTranslation(
                intl,
                unsafeTranslationKey(labels?.[availableValue] ?? availableValue)
              )}
              key={availableValue}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
}
